import estherPic from "@/public/images/artists/esther.png";
import { Artist } from "@/types/types";

export const esther = {
  id: "298",
  name: "Esther",
  image: estherPic,
  description: `Esther has a luminous voice with an effortless upper register, graceful vibrato, and expressive phrasing.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Festher-preview.mp3",
  meta: {
    free: false,
    new: true,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Classical"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "Very high",
      },
      specific: {
        low: 57,
        high: 76,
      },
      sweetSpot: 66,
    },
  },
} as const satisfies Artist;
